module.exports = __webpack_public_path__ + "img/whiteUpArrow.7ab7c23f.svg";